import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Chip, OutlinedInput, Box } from '@mui/material';

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.2)' },
    '&:hover fieldset': { borderColor: '#F6911D' },
    '&.Mui-focused fieldset': { borderColor: '#F6911D' },
  },
  '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.6)' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#F6911D' },
  '& .MuiSelect-select': { color: 'white' },
};

const menuProps = {
  PaperProps: {
    sx: {
      backgroundColor: '#1a1a1a',
      color: 'white',
      '& .MuiMenuItem-root': {
        '&:hover': {
          backgroundColor: 'rgba(246, 145, 29, 0.1)',
        },
        '&.Mui-selected': {
          backgroundColor: 'rgba(246, 145, 29, 0.2)',
          '&:hover': {
            backgroundColor: 'rgba(246, 145, 29, 0.3)',
          },
        },
      },
    },
  },
};

function MultiSelectField({ label, value = [], onChange, options, required = false }) {
  return (
    <FormControl fullWidth sx={textFieldStyles} required={required}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value.map((v) => (typeof v === 'object' ? v.id : v))}
        onChange={(e) => {
          const selected = e.target.value;
          onChange(selected.map((v) => (typeof v === 'object' ? v.id : v)));
        }}
        input={<OutlinedInput label={label} />}
        renderValue={(selectedIds) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selectedIds.map((id) => {
              const option = options.find((o) => o.id === id);
              return (
                <Chip
                  key={id}
                  label={option ? option.name : id}
                  size="small"
                  sx={{
                    background: 'rgba(246, 145, 29, 0.2)',
                    color: '#F6911D',
                    border: '1px solid rgba(246, 145, 29, 0.3)',
                  }}
                />
              );
            })}
          </Box>
        )}
        MenuProps={menuProps}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultiSelectField;
